import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { Schedule } from '@/models/domain/Schedule'

export interface ScheduleCancelStore {
  data?: Schedule
  setData(data: Schedule): void
  setSource(source: string): void
  source: string
  reset: () => void
}

type InitialStateStore = Omit<
  ScheduleCancelStore,
  'setData' | 'setSource' | 'reset'
>

const initialState: InitialStateStore = {
  data: undefined,
  source: ''
}

export const useScheduleCancelStore = create<ScheduleCancelStore>()(
  devtools(
    (set) => ({
      source: '',
      setData(data: Schedule) {
        set({ data }, false, 'setData')
      },
      setSource(source) {
        set({ source }, false, 'setSource')
      },
      reset: () => {
        set(initialState)
      }
    }),
    {
      name: 'useScheduleCancelStore'
    }
  )
)
